module.exports = __webpack_public_path__ + "static/media/5.38bd74f4.jpeg";